
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import Swiper from "swiper"
import Footer from "@/components/lyx-components/lyx-footer/index"
import loading from '@/components/public-components/loading/index.vue'
import mapUtil from '@/javascript/mapUtil'
import EsQuery from '@/javascript/esQuery'
import util from '@/javascript/util'
import goBack from '@/components/public-components/goBack/index.vue'

export default {
components: {
Tab,
TabItem,
loading,
Footer,
goBack
},
computed: {
computedSearchUrl() {
switch(this.tabsIndex) {
case 0:
return '/search?type=8&code=' + this.XXCJ_TYPE_CODE.LYSFC;
case 1:
return '/search?type=9'
case 2:
return '/search?type=10'
}
}
},
data () {
return {
currentSwiper: null,
tabs: [{
name: '美丽乡村',
code: this.INDEX_NAME_TYPE.scenic,
url: '/api/wtcp-bics/public/scenic/getOne/',
entity: 'scenicEntity'
},{
name: '自驾营地',
code: this.INDEX_NAME_TYPE.driveCamp,
url: '/api/wtcp-bics/public/driveCamp/getOne/',
entity: 'driveCampEntity'
},{
name: '农家乐',
code: this.INDEX_NAME_TYPE.rural,
url: '/api/wtcp-bics/public/entertainment/getOne/',
entity: 'entertainmentEntity'
}],
tabsIndex: 0,
bgImg: '',
minHeight: 0,
isShow: false,
cityData: [],
scenicsListFrom: {
pageNo: 0,
pageSize: 7
},
scenicListBar: [],
scenicList: [],
infiniteAll: false,
infiniteStatus: false,
location: {},
swiper: null,
isLoop: false,
isWeixin: util.isWeiXin()
}
},
filters: {

},
mounted () {
this.minHeight = document.documentElement.clientHeight;
document.title = this.PAGE_TITLE + "乡村游";

switch(localStorage.getItem('njl-entity')) {
case 'driveCampEntity':
this.tabsIndex = 1
break
case 'entertainmentEntity':
this.tabsIndex = 2
break
case 'scenicEntity':
default:
this.tabsIndex = 0
break
}
localStorage.setItem('njl-entity', '')



















mapUtil.locate((data) => {
this.locationResult(data);
this.initBar()
this.getScenicList()
}, (data) => {
if (data == undefined) {
this.$notify({
title: '警告',
message: '定位失败，请开启定位权限',
type: 'warning'
});
data = {
location: {
position: {
lng: 101.026748,
lat: 36.872229
}
}
}
this.locationResult(data);
this.initBar()
this.getScenicList()
} else {
this.locationResult(data);
this.initBar()
this.getScenicList()
}
}) // 获取当前位置经纬度


},
methods: {
tabClick(index) {
this.tabsIndex = index
this.scenicsListFrom.pageNo = 0
this.scenicList.length = 0
this.scenicListBar.length = 0
this.infiniteAll = false
this.initBar()
this.getScenicList()
},
initBar () {
const _this = this
const querystring = require('querystring')
const recommendEsQuery = new EsQuery()
recommendEsQuery
.addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, recommendEsQuery.and, false)

.addString('tags', '推荐', recommendEsQuery.and, false)
.addSort("weight", recommendEsQuery.desc, false)
.addPage(0,20)

if (this.tabsIndex == 0) {
recommendEsQuery.addStartWith('category', this.XXCJ_TYPE_CODE.LYSFC, recommendEsQuery.and, false)
}

const recommendEsJsonQuery = JSON.stringify(recommendEsQuery.getArray())
this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
'indexName': this.tabs[this.tabsIndex].code,
'esJsonQuery': recommendEsJsonQuery
})).then((response) => {




_this.$set(_this, "scenicListBar", response.data.data.map((scenic) => {

scenic._source.areaName = scenic._source.regionFullName.split(",");
scenic._source.distance = this.location.position ? mapUtil.getDistance(this.location.position.lng, this.location.position.lat, scenic._source.longitude, scenic._source.latitude) : '<1km'
this.namelength = scenic._source.areaName.length


return scenic._source
})
);


if (this.scenicListBar.length > 1) {
this.isLoop = true;
} else {
this.isLoop = false;
}
if (this.currentSwiper != null) {
this.currentSwiper.destroy(true, true)
}
this.$nextTick(() => {
this.currentSwiper = new Swiper(".scenic-swiper", {
slidesPerView: "auto",
centeredSlides: !this.isLoop,
spaceBetween: 20,
loop: false,
onSlideChangeEnd: function (swiper) {
_this.bgImg = _this.scenicListBar[swiper.activeIndex % _this.scenicListBar.length].images[0];
}
})
})
})
},
locationResult (val) {
this.location = val

},
onItemClick ({ cityId }) {
this.scenicsListFrom.pageNo = 0
this.infiniteAll = false
this.infiniteStatus = true
this.scenicList = []
this.$router.replace('/scenicList/' + cityId)
this.getScenicList()
},

getScenicList: function () {
const querystring = require('querystring')
const recommendEsQuery = new EsQuery()
recommendEsQuery.addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, recommendEsQuery.and, false)
.addPage(this.scenicsListFrom.pageNo * this.scenicsListFrom.pageSize, this.scenicsListFrom.pageSize)
.addSort("weight", recommendEsQuery.desc, false)

if (this.tabsIndex == 0) {
recommendEsQuery.addStartWith('category', this.XXCJ_TYPE_CODE.LYSFC, recommendEsQuery.and, false)
}

const recommendEsJsonQuery = JSON.stringify(recommendEsQuery.getArray())
this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
'indexName': this.tabs[this.tabsIndex].code,
'esJsonQuery': recommendEsJsonQuery
})).then((response) => {
window.addEventListener('scroll', this.windowScroll) 
const scenics = response.data.data,
scenicList = scenics.map(scenic => {
scenic._source.areaName = scenic._source.regionFullName.split(",");


scenic._source.distance = this.location.position ? mapUtil.getDistance(this.location.position.lng, this.location.position.lat, scenic._source.longitude, scenic._source.latitude) : '<1km'
this.namelength = scenic._source.areaName.length
return scenic._source
})
this.scenicList = this.scenicList.concat(scenicList)
if (response.data.data.length < this.scenicsListFrom.pageSize) {
this.infiniteAll = true
}
this.infiniteStatus = false
})
},
windowScroll (e) {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
if (scrollTop > 0) {
this.isShow = true
} else {
this.isShow = false
}

if (util.pullUpLoad()) {
this.infinite()
}
},
infinite () {
if (this.infiniteAll) {
return
}
if (this.infiniteStatus) {
return
}
this.scenicsListFrom.pageNo += 1
this.infiniteStatus = true
this.getScenicList()
}
}
}
